export class StoreAuthException extends Error {}
export class StoreConflictException extends Error {}
export class StoreUnreachableException extends Error {}
export class ConnectivityException extends Error {}
